import React from 'react';
import { Image, View } from 'react-native';
import TouchableElement from '@components/common/touchableElement';
import { navigateTo } from '@helpers';
import LinearGradient from 'react-native-linear-gradient';
import { Shadow, getElevation } from '@styles/shadow';
import { useHandleImageNavigation } from '@v2/pages/common/hooks/useHandleImageNavigation';

export default React.memo(
  ({ source, style, resizeMode, hovered, imgSize, data, action, borderRadius, isShadow, isOverlay, shadowColor, C }) => {
    const { handleImageNavigation } = useHandleImageNavigation();

    const Component = ({ boxStyle = {} }) => (
      <View style={style}>
        {isShadow && hovered && <Shadow {...{ borderRadius: borderRadius || 0, type: 'Field', bg: shadowColor }} />}
        <View style={{ width: '100%', height: '100%', overflow: 'hidden', borderRadius: borderRadius || 0 }}>
          {isOverlay && C && (
            <View style={{ backgroundColor: C('Overlay/Light/Picture white'), width: '100%', height: '100%', position: 'absolute', zIndex: 3 }} />
          )}
          {isOverlay && C && (
            <View style={{ backgroundColor: C('Overlay/Light/Dim light'), width: '100%', height: '100%', position: 'absolute', zIndex: 2 }} />
          )}
          <Image style={[style]} resizeMode={resizeMode} source={source} />
        </View>
        {imgSize && (
          <LinearGradient colors={['rgba(0, 0, 0, 0.03)', 'rgba(0, 0, 0, 0.04)']} style={[boxStyle, imgSize, { position: 'absolute', zIndex: 10 }]} />
        )}
      </View>
    );

    if (!action && !data) {
      return <Component />;
    }

    return (
      <TouchableElement
        onPress={() => {
          if (action) {
            action();
            return;
          }
          if (data) {
            handleImageNavigation(data);
          }
        }}
      >
        {({ boxStyle, hovered }) => (
          <View style={[boxStyle, style, isShadow && hovered && { elevation: getElevation('Field') }]}>
            <Component {...{ boxStyle }} />
          </View>
        )}
      </TouchableElement>
    );
  },
  (prev, next) => prev.source?.uri === next.source?.uri && prev.C?.scheme === next.C?.scheme
);
